import { Container } from 'reactstrap'
import styles from './Customers.module.scss'
import DataTable from 'react-data-table-component'

const Customers = () => {

  const data = [
    { customerId: '001', customerName: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: 'Active' },
    { customerId: '001', customerName: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: 'Active' },
    { customerId: '001', customerName: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: 'Active' },
  ]

  const columns = [
    { name: 'Customer ID', selector: row => row.customerId },
    { name: 'Customer name', selector: row => row.customerName },
    { name: 'Email Address', selector: row => row.email },
    { name: 'Phone number', selector: row => row.phoneNo },
    { name: 'Status', selector: row => row.status },
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <section>
      <div className={styles['heading']}>Customers</div>
      <Container className="px-5 d-flex flex-column gap-2 py-2">

        <div>
          <p>Total Added Customer: <span className={styles['text-orange']}>4</span></p>
        </div>

        <DataTable data={data} columns={columns} customStyles={customStyles} />

      </Container>
    </section>
  )
}

export default Customers